export const common = {
  // Navigation
  'nav.features': '기능',
  'nav.howItWorks': '작동 방식',
  'nav.pricing': '가격',
  'nav.faq': 'FAQ',
  'nav.aboutUs': '회사 소개',
  'nav.getStarted': '시작하기',

  // About Us Section
  'aboutUs.badge': '회사 소개',
  'aboutUs.title': '회사 소개',
  'aboutUs.line1': '아이디어는 싸다.',
  'aboutUs.line2': '자본은 그렇지 않다. 시간은 더더욱.',
  'aboutUs.paragraph1': 'IdeaOracle.ai는 대부분의 비즈니스 아이디어가 용기 부족이 아닌 정직함의 부족으로 실패하기 때문에 설립되었습니다. 너무 많은 확인. 너무 적은 현실.',
  'aboutUs.belief1a': '우리는 과대광고를 믿지 않습니다.',
  'aboutUs.belief1b': '우리는 시장 논리를 믿습니다.',
  'aboutUs.belief2a': '우리는 동기부여를 믿지 않습니다.',
  'aboutUs.belief2b': '우리는 수요, 경쟁, 차별화를 믿습니다.',
  'aboutUs.mission1': '우리의 임무는 아이디어를 좋아 보이게 만드는 것이 아닙니다.',
  'aboutUs.mission2': '우리의 임무는 그 실현 가능성을 밝히는 것입니다.',
  'aboutUs.analysis': 'IdeaOracle.ai는 구조적 시장 메커니즘, 현실적 수요, 경쟁 강도 및 실현 가능성에 대해 비즈니스 틈새시장을 분석합니다. 감정적이지 않게. 낙관적이지 않게. 냉정하게.',
  'aboutUs.failure1': '대부분의 아이디어는 실패합니다.',
  'aboutUs.failure2': '창업자가 무능해서가 아니라 –',
  'aboutUs.failure3': '사전에 아무도 충분히 명확하지 않았기 때문입니다.',
  'aboutUs.clarity': '우리는 그 명확성을 제공하기 위해 존재합니다.',
  'aboutUs.value1': '불편하게.',
  'aboutUs.value2': '직접적으로.',
  'aboutUs.value3': '일관되게.',
  'aboutUs.confirm': '아이디어에 실체가 있으면 확인합니다.',
  'aboutUs.deny': '없으면 그것도 말합니다.',
  'aboutUs.noApplause': '박수 없이.',
  'aboutUs.noSugarcoating': '미화 없이.',
  'aboutUs.noTheater': '연극 없이.',

  // Hero Section
  'hero.badge': '비즈니스 틈새시장을 위한 의사결정 AI',
  'hero.title1': '아이디어는 저렴합니다.',
  'hero.title2': '나쁜 결정은 그렇지 않습니다.',
  'hero.subtitle': '투자하기 전에',
  'hero.subtitleLine2': '비즈니스 틈새시장을 평가하는 AI.',
  'hero.cta': '아이디어 확인',
  'hero.ctaSecondary': '작동 방식',
  'hero.stat1Value': '30',
  'hero.stat1Label': '요청당 크레딧',
  'hero.stat2Value': '7+',
  'hero.stat2Label': '평가 수준',
  'hero.stat3Value': '100%',
  'hero.stat3Label': '정직하고 비공개',

  // Features Section
  'features.title1': '강력한 기능으로',
  'features.title2': '현대',
  'features.title3': '비즈니스 지원',
  'features.honestVerdict.title': '허세 점수가 아닌 솔직한 평가',
  'features.honestVerdict.description': '실제 시장 데이터와 경쟁사 조사에 근거한 명확한 좋음/보통/약함 평가. 모든 아이디어를 띄워주려는 9/10 점수는 없습니다.',
  'features.fullJourney.title': '아이디어 점검에서 Builder Report까지',
  'features.fullJourney.description': '채팅에서 검증하고, 시장 분석을 심도 있게 파고, 페르소나·재무·Go-to-Market·피치덱이 포함된 25~75페이지 Builder Report를 내보내세요.',
  'features.multilingual.title': '21개 언어, 로컬 시장 데이터',
  'features.multilingual.description': '스위스 중소기업부터 상파울루의 1인 창업자까지 — AI가 당신의 언어로, 당신의 시장 출처로 답변합니다.',

  // How It Works
  'howItWorks.title': '작동 방식',
  'howItWorks.subtitle': '비즈니스 틈새시장에 대한 명확성을 위한 4단계.',
  'howItWorks.step1Title': '플랜 선택',
  'howItWorks.step1Desc': 'Starter, Pro 또는 Builder - 검토 깊이에 따라.',
  'howItWorks.step2Title': 'AI에게 질문',
  'howItWorks.step2Desc': '틈새시장에 대해 질문하세요. 각 요청은 30크레딧이 소요됩니다.',
  'howItWorks.step3Title': '정직한 평가 받기',
  'howItWorks.step3Desc': 'AI가 평가합니다: 좋음, 보통, 나쁨. 꾸밈없이.',
  'howItWorks.step4Title': '결정 내리기',
  'howItWorks.step4Desc': '이제 계속 진행할 가치가 있는지 알 수 있습니다.',

  // Pricing
  'pricing.title': '가격',
  'pricing.subtitle': '검토 깊이에 맞는 플랜을 선택하세요.',
  'pricing.yearlyDiscount': '연간 구독:',
  'pricing.yearlyDiscountValue': '-20% 할인',
  'pricing.perMonth': '월',
  'pricing.selectPlan': '플랜 선택',
  'pricing.mostPopular': '가장 인기',
  'pricing.footer': '모든 가격은 CHF입니다. 크레딧은 성공적인 AI 응답에 대해서만 차감됩니다.',
  
  // Starter Plan
  'pricing.starter.name': 'Starter',
  'pricing.starter.description': '초기 현실 테스트용.',
  'pricing.starter.credits': '2,500 크레딧',
  'pricing.starter.feature1': '틈새 아이디어 생성',
  'pricing.starter.feature2': '틈새 다듬기',
  'pricing.starter.feature3': '시장 현실 확인',
  'pricing.starter.feature4': '경쟁 평가',
  'pricing.starter.feature5': '타이밍 평가',
  'pricing.starter.feature6': '정직한 평가',
  'pricing.starter.feature7': '비공개 세션',
  'pricing.starter.feature8': '기록 및 내보내기',

  // Pro Plan
  'pricing.pro.name': 'Pro',
  'pricing.pro.description': '더 깊은 검토용.',
  'pricing.pro.credits': '5,000 크레딧',
  'pricing.pro.feature1': '모든 Starter 기능',
  'pricing.pro.feature2': '집중 검토를 위한 추가 크레딧',
  'pricing.pro.feature3': '개선 제안',
  'pricing.pro.feature4': '대체 틈새시장',
  'pricing.pro.feature5': '상세한 시장 분석',
  'pricing.pro.feature6': '우선 지원',
  'pricing.pro.feature7': '고급 필터',
  'pricing.pro.feature8': '세션 즐겨찾기',

  // Builder Plan
  'pricing.builder.name': 'Builder',
  'pricing.builder.description': '아이디어 → 개발자 브리핑.',
  'pricing.builder.credits': '무제한 크레딧',
  'pricing.builder.feature1': '모든 Pro 기능',
  'pricing.builder.feature2': '무제한 AI 요청',
  'pricing.builder.feature3': 'Builder 모드: 개발자 브리핑',
  'pricing.builder.feature4': '구조화된 프로젝트 개요',
  'pricing.builder.feature5': '사용자 흐름 및 핵심 기능',
  'pricing.builder.feature6': '기술 노트',
  'pricing.builder.feature7': '비목표 정의',
  'pricing.builder.feature8': '공정 사용 속도 제한',
  'pricing.builder.limitNote': '공정 사용 제한',
  'pricing.monthlyReset': '월간 재설정',

  // Modal
  'pricing.modal.selected': '선택됨',
  'pricing.modal.comingSoon': '등록 및 결제 처리가 곧 제공됩니다.',
  'pricing.modal.patience': '안전하고 원활한 경험을 제공하기 위해 노력하고 있습니다. 기다려 주세요.',
  'pricing.modal.understood': '이해했습니다',

  // FAQ
  'faq.title': 'FAQ',
  'faq.subtitle': '정직하고 비판적으로 답변.',
  'faq.q1': 'IdeaOracle.ai는 구체적으로 무엇을 하나요?',
  'faq.a1': 'IdeaOracle.ai는 비즈니스 아이디어와 틈새시장을 시장 논리, 실제 수요, 경쟁, 차별화 및 실현 가능성 측면에서 평가합니다.\n실체가 있으면 전략적으로 어떻게 날카롭게 할 수 있는지 보여줍니다.\n없으면 그렇게 말합니다.',
  'faq.q2': '아이디어도 생성하나요?',
  'faq.a2': '예.\n하지만 맹목적으로는 아닙니다.\n시장 논리에 기반한 접근 방식을 개발합니다 – 동기부여나 트렌드 과대광고가 아닌.',
  'faq.q3': '비즈니스 모델을 최적화하나요?',
  'faq.a3': '예 – 잠재력이 있다면.\n환상을 다듬지 않습니다.\n실행 가능한 개념을 더 견고하게 만듭니다.',
  'faq.q4': '다른 AI 도구와 무엇이 다른가요?',
  'faq.a4': '다른 도구는 영감을 제공합니다.\n우리는 평가를 제공합니다.\n초점은 현실주의이지 열정이 아닙니다.',
  'faq.q5': '성공의 보장인가요?',
  'faq.a5': '아니요.\n잘못된 결정을 줄입니다 – 위험을 제거하지는 않습니다.',
  'faq.q6': 'IdeaOracle.ai는 누구를 위한 것인가요?',
  'faq.a6': '출시 전 창업자\n확장 전 기업가\n시간 투자 전 사이드 빌더\n검토 전 투자자\n\n요약: 자본보다 명확성을 원하는 사람들을 위해.',
  'faq.q7': '단지 확인만 찾고 있다면?',
  'faq.a7': '그렇다면 IdeaOracle.ai는 적합한 도구가 아닙니다.',
  'faq.q8': '분석은 얼마나 정직한가요?',
  'faq.a8': '데이터와 시장 메커니즘이 허용하는 만큼 정직합니다.\n도취 없음. 관용 없음.',
  'faq.q9': '시장 조사를 대체하나요?',
  'faq.a9': '아니요.\n우리는 전략적 사전 평가입니다 – 완전한 시장 연구가 아닙니다.',
  'faq.q10': '왜 그렇게 타협하지 않나요?',
  'faq.a10': '실패는 비싸기 때문입니다.\n정직함은 그렇지 않습니다.',

  // Footer
  'footer.description': '이 플랫폼은 기분을 좋게 하는 것이 아니라 올바른 결정을 내리는 데 도움을 줍니다.',
  'footer.product': '제품',
  'footer.aiAssistant': 'AI 어시스턴트',
  'footer.howItWorks': '작동 방식',
  'footer.pricing': '가격',
  'footer.faq': 'FAQ',
  'footer.legal': '법적 고지',
  'footer.privacy': '개인정보',
  'footer.terms': '약관',
  'footer.imprint': '임프린트',
  'footer.support': '지원',
  'footer.contact': '연락처',
  'footer.documentation': '문서',
  'footer.copyright': '© 2025 IdeaOracle.ai. 모든 권리 보유.',

  // AI Assistant
  'aiAssistant.title': 'AI 틈새시장 어시스턴트',
  'aiAssistant.subtitle': '틈새시장에 대한 질문',
  'aiAssistant.welcomeMessage': '안녕하세요! 아이디어를 설명하거나 틈새시장에 대해 질문하세요. 명확하고 정직한 평가를 제공합니다.',
  'aiAssistant.demoResponse': '이것은 데모입니다. 실제 AI 평가를 받으려면 등록하고 플랜을 선택하세요.',
  'aiAssistant.placeholder': '아이디어를 설명하세요...',

  // Header & Sidebar
  'dashboard.header.title': '대시보드',
  'dashboard.sidebar.overview': '개요',
  'dashboard.sidebar.newAnalysis': 'AI 어시스턴트',
  'dashboard.sidebar.history': '기록',
  'dashboard.sidebar.credits': '크레딧',
  'dashboard.sidebar.settings': '설정',

  // Dashboard Overview
  'dashboard.overview.welcome': '다시 오신 것을 환영합니다, {{name}}',
  'dashboard.overview.subtitle': '활동에 대한 빠른 개요입니다',

  // Dashboard Stats
  'dashboard.stats.creditsRemaining': '남은 크레딧',
  'dashboard.stats.totalAnalyses': '총 분석',
  'dashboard.stats.goodRatings': '긍정적 평가',
  'dashboard.stats.nextReset': '다음 재설정까지',
  'dashboard.stats.days': '일',

  // Quick Actions
  'dashboard.quickActions.title': '빠른 작업',
  'dashboard.quickActions.checkNewIdea': '아이디어 확인',
  'dashboard.quickActions.checkNewIdeaDesc': '기존 비즈니스 아이디어 분석',
  'dashboard.quickActions.generateIdea': '아이디어 생성',
  'dashboard.quickActions.generateIdeaDesc': '새로운 수익성 있는 틈새시장 찾기',
  'dashboard.quickActions.builderBriefing': 'Builder 브리핑',
  'dashboard.quickActions.builderBriefingDesc': '아이디어를 개발자용 브리핑으로 변환',
  'dashboard.quickActions.premiumOnly': 'Builder 전용',

  // Chat Header
  'chat.title': 'AI 틈새시장 어시스턴트',
  'chat.subtitle': '틈새시장에 대해 질문하세요. 비판적이고 정직하게 평가합니다.',
  'chat.creditsLabel': '크레딧',

  // Chat Welcome
  'chat.welcomeTitle': 'AI 틈새시장 어시스턴트에 오신 것을 환영합니다',
  'chat.welcomeDesc': '아이디어를 설명하거나 틈새시장에 대해 질문하세요. 정직하게 평가합니다: 좋음, 보통, 나쁨.',
  'chat.aiWelcome': '안녕하세요! 아이디어를 설명하거나 틈새시장에 대해 질문하세요. 명확하고 정직한 평가를 제공합니다.',

  // Chat Suggestions
  'chat.suggestion1': '수익성 있는 틈새시장을 찾아주세요.',
  'chat.suggestion2': '아이디어가 있습니다 - 정직하게 평가해주세요.',
  'chat.suggestion3': '지금 어떤 틈새시장에 잠재력이 있나요?',
  'chat.suggestion4': '이 틈새시장을 다듬고 더 구체적으로 만들어주세요.',

  // Chat Actions
  'chat.newConversation': '새 대화',
  'chat.today': '오늘',
  'chat.yesterday': '어제',
  'chat.thisWeek': '이번 주',
  'chat.thisMonth': '이번 달',
  'chat.older': '이전',
  'chat.messages': '메시지',
  'chat.renameConversation': '이름 변경',
  'chat.deleteConversation': '삭제',
  'chat.cancel': '취소',
  'chat.rename': '이름 변경',
  'chat.delete': '삭제',
  'chat.favorite': '즐겨찾기 추가',
  'chat.unfavorite': '즐겨찾기 제거',
  'chat.searchSessions': '대화 검색...',
  'chat.noResults': '결과를 찾을 수 없습니다',
  'chat.noSessions': '아직 대화가 없습니다',
  'chat.enterNewName': '새 이름 입력...',
  'chat.deleteConfirmMessage': '이 대화를 삭제하시겠습니까? 이 작업은 취소할 수 없습니다.',

  // Chat Input & Errors
  'chat.inputPlaceholder': '질문을 입력하세요… (30크레딧 소요)',
  'chat.send': '보내기',
  'chat.voice': '말하기',
  'chat.listeningPlaceholder': '듣고 있습니다... 지금 말하세요.',
  'chat.stopListening': '녹음 중지',
  'chat.recording': '녹음 중...',
  'chat.speechNotSupported': '브라우저에서 음성 인식을 지원하지 않습니다.',
  'chat.microphonePermissionDenied': '마이크 액세스가 거부되었습니다. 브라우저 설정에서 액세스를 허용하세요.',
  'chat.errorNotEnoughCredits': '크레딧이 부족합니다. 플랜을 업그레이드하거나 다음 재설정을 기다리세요.',
  'chat.errorAiFailed': 'AI 응답이 실패했습니다. 크레딧이 차감되지 않았습니다.',
  'chat.errorRateLimit': '요청이 너무 많습니다. 잠시 기다려주세요.',

  // Ratings
  'rating.good': '좋음',
  'rating.medium': '보통',
  'rating.bad': '나쁨',

  // Auth Page
  'auth.branding.headline1': '모든 아이디어가 좋은 것은 아닙니다.',
  'auth.branding.headline2': '어떤 것이 좋은지 솔직하게 말씀드립니다.',
  'auth.branding.subtitle': '비즈니스 틈새시장을 위한 의사결정 AI. 명확하게. 비판적으로. 꾸밈없이.',
  'auth.benefits.privacy.title': '100% 비공개',
  'auth.benefits.privacy.desc': '아이디어는 완전히 비공개로 안전하게 보관됩니다.',
  'auth.benefits.honest.title': '정직한 AI',
  'auth.benefits.honest.desc': '꾸밈없이 – 명확하고 비판적인 피드백만.',
  'auth.benefits.fast.title': '빠른 결과',
  'auth.benefits.fast.desc': '몇 분 안에 틈새시장에 대한 명확성을 얻으세요.',
  'auth.trust.users': '활성 사용자',
  'auth.trust.ideas': '분석된 아이디어',
  'auth.trust.rating': '평점',
  'auth.login.title': '로그인',
  'auth.login.headline': '다시 오신 것을 환영합니다',
  'auth.login.subtitle': '로그인하여 여정을 계속하세요.',
  'auth.login.forgotPassword': '비밀번호를 잊으셨나요?',
  'auth.login.submit': '로그인',
  'auth.login.noAccount': '계정이 없으신가요?',
  'auth.login.signUp': '가입하기',
  'auth.register.title': '가입',
  'auth.register.headline': '계정 만들기',
  'auth.register.subtitle': '오늘부터 비즈니스 아이디어 분석을 시작하세요.',
  'auth.register.submit': '계정 만들기',
  'auth.register.hasAccount': '이미 계정이 있으신가요?',
  'auth.register.signIn': '로그인',
  'auth.fields.name': '이름',
  'auth.fields.email': '이메일 주소',
  'auth.fields.password': '비밀번호',
  'auth.fields.confirmPassword': '비밀번호 확인',
  'auth.fields.selectPlan': '플랜 선택',
  'auth.placeholders.name': '이름을 입력하세요',
  'auth.placeholders.email': '이메일을 입력하세요',
  'auth.placeholders.password': '비밀번호를 입력하세요',
  'auth.placeholders.confirmPassword': '비밀번호를 확인하세요',
  'auth.terms.accept': '동의합니다',
  'auth.terms.terms': '이용약관',
  'auth.privacy.accept': '동의합니다',
  'auth.privacy.policy': '개인정보 처리방침',
  'auth.errors.nameRequired': '이름은 필수입니다',
  'auth.errors.emailRequired': '이메일은 필수입니다',
  'auth.errors.emailInvalid': '유효한 이메일을 입력하세요',
  'auth.errors.passwordRequired': '비밀번호는 필수입니다',
  'auth.errors.passwordLength': '비밀번호는 최소 8자 이상이어야 합니다',
  'auth.errors.passwordMismatch': '비밀번호가 일치하지 않습니다',
  'auth.loading': '잠시만 기다려주세요...',
  'auth.or': '또는 계속하기',
  'auth.social.google': 'Google로 계속하기',
  'auth.social.apple': 'Apple로 계속하기',

  // Trial Plan
  'pricing.trial.name': 'Trial',
  'pricing.trial.description': '3일 무료 이용',
  'pricing.trial.credits': '250 크레딧',
  'pricing.trial.free': '무료',
  'pricing.trial.duration': '3일간 무료',
  'pricing.trial.cta': '무료 체험 시작',
  'pricing.trial.feature1': 'AI를 체험할 수 있는 250 크레딧',
  'pricing.trial.feature2': '3일간 전체 이용',
  'pricing.trial.feature3': '신용카드 불필요',
  'pricing.trial.feature4': '언제든지 취소 가능',

  // Gold Package
  'pricing.gold.name': 'Gold',
  'pricing.gold.description': '10,000 크레딧 + 25페이지 Builder 리포트',
  'pricing.gold.credits': '10,000 크레딧',
  'pricing.gold.feature1': '10,000 크레딧',
  'pricing.gold.feature2': '25페이지 Builder 리포트',
  'pricing.gold.feature3': 'Starter 및 Pro의 모든 기능',
  'pricing.gold.feature4': '시장 분석 및 요약',
  'pricing.gold.feature5': '기회, 위험, 권장사항',
  'pricing.gold.feature6': 'PDF 다운로드',
  'pricing.gold.feature7': '지원',

  // Platinum Package
  'pricing.platinum.name': 'Platinum',
  'pricing.platinum.description': '15,000 크레딧 + 100페이지 Builder 리포트',
  'pricing.platinum.credits': '15,000 크레딧',
  'pricing.platinum.feature1': '15,000 크레딧',
  'pricing.platinum.feature2': '100페이지 Builder 리포트',
  'pricing.platinum.feature3': 'Gold의 모든 기능',
  'pricing.platinum.feature4': 'Builder 모드: 개발자 브리핑',
  'pricing.platinum.feature5': '구조화된 요약',
  'pricing.platinum.feature6': '고급 시장 분석',
  'pricing.platinum.feature7': '지원',

  // Pricing UI
  'pricing.monthly': '월간',
  'pricing.yearly': '연간',
  'pricing.savings': '할인',
  'pricing.billedYearly': '연간 청구',

  // Hero trial CTA
  'hero.trialTitle': '무료 체험 시작하기',
  'hero.creditsLabel': '크레딧',
  'hero.trialTagline': 'AI 어시스턴트를 3일간 무료로 체험하세요',
  'hero.trialCta': '가입하고 250 크레딧 받기',
  'hero.trialNoCard': '신용카드 불필요. 약정 없음.',

  // Admin
  'admin.dashboard.tabs.plans': '플랜',

  // Credit top-up
  'dashboard.credits.topup.button': '크레딧 충전',
  'dashboard.credits.topup.buttonTitle': '플랜을 변경하지 않고 크레딧을 추가 구매',
  'dashboard.credits.topup.title': '크레딧 충전',
  'dashboard.credits.topup.subtitle': '크레딧당 CHF 0.15 — 플랜 변경 불필요',
  'dashboard.credits.topup.quickAmounts': '빠른 선택',
  'dashboard.credits.topup.custom': '사용자 지정',
  'dashboard.credits.topup.totalLabel': '합계',
  'dashboard.credits.topup.creditsLabel': '크레딧',
  'dashboard.credits.topup.confirm': '지금 구매',
  'footer.disclaimer': '면책 조항',
  'legal.backToHome': '홈으로 돌아가기',
  'legal.lastUpdated': '마지막 업데이트',
  'legal.allRightsReserved': '모든 권리 보유.',
  'legal.authoritativeNotice': '귀하의 언어로 로컬라이즈된 버전은 아직 제공되지 않습니다. 법적 효력을 지닌 영어 원문이 아래에 표시됩니다.',
  'legal.translationNotice': '이는 편의를 위한 번역본입니다. 법적 효력을 가지는 원본은 영어판입니다.',
};

export default common;
